import styled, { css } from 'styled-components';

const ToolbarContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  ${(props) =>
    !!props.noPaddingX &&
    css`
      padding-left: 0;
      padding-right: 0;
    `}
`;

export default ToolbarContainer;
